export const WEIGHT = { MIN: 30, MAX: 250 };
export const WEIGHT_LBS = { MIN: 66, MAX: 551 }; // 30kg to 250kg in pounds
export const AGE = { MIN: 18, MAX: 100 };
export const SERUM = { MIN: 5, MAX: 10000 }; // micromol/L range
export const SERUM_MG_DL = "mg/dL";
export const SERUM_MG_DL_RANGE = { MIN: 0.06, MAX: 113.12 }; // mg/dL range (5-10000 micromol/L converted)
export const HEIGHT_GFR_CM = { MIN: 50, MAX: 220 };
export const HEIGHT_GFR_IN = { MIN: 20, MAX: 86 }; // 50cm to 220cm in inches
export const SERUM_GFR = { MIN: 20, MAX: 1000 };
export const SERUM_GFR_MG_DL_RANGE = { MIN: 0.23, MAX: 11.31 }; // mg/dL range (20-1000 micromol/L converted)
export const FEET_RANGE = { MIN: 1, MAX: 7 };
export const INCHES_RANGE = { MIN: 0, MAX: 11.9 };
export const HEIGHT_CM = { MIN: 90, MAX: 220 };
export const HEIGHT_IN = { MIN: 35, MAX: 86 }; // 90cm to 220cm in inches

// Relaxed ranges for non-clinical calculators (BSA, IBW, LBW)
export const WEIGHT_RELAXED = { MIN: 2, MAX: 250 };
export const WEIGHT_LBS_RELAXED = { MIN: 4.4, MAX: 551 }; // 2kg to 250kg in pounds
export const HEIGHT_CM_RELAXED = { MIN: 50, MAX: 220 };
export const HEIGHT_IN_RELAXED = { MIN: 20, MAX: 86 }; // 50cm to 220cm in inches

export const CREATININE_CONVERSION = {
  MG_DL_TO_MICROMOL_L: 88.4,
  MICROMOL_L_TO_MG_DL: 1 / 88.4,
  MILLIMOL_L_TO_MICROMOL_L: 1000,
  MICROMOL_L_TO_MILLIMOL_L: 1 / 1000,
};

export const BMI_THRESHOLDS = {
  UNDERWEIGHT: 18.5,
  NORMAL_MAX: 25,
  OBESE_SINGLE_DOSE: 35, // BMI >= 35 requires single dose only
};

export const CRCL_THRESHOLDS = {
  LOW: 40, // CrCl < 40: reduced dosing
  NORMAL: 60, // CrCl > 60: normal dosing, CrCl 40-60: intermediate dosing
};

export const AMINOGLYCOSIDE_DOSING = {
  // Amikacin dosing (mg/kg)
  AMIKACIN: {
    NORMAL_CRITICAL: 30, // Normal renal function or critical care
    INTERMEDIATE: 20, // CrCl 40-60
    REDUCED: 15, // CrCl < 40
    MAX_DOSE: 2500, // Maximum dose cap (mg)
    MAX_INTERMEDIATE: 1625, // Max dose for CrCl 40-60 (mg)
    MAX_REDUCED: 1250, // Max dose for CrCl < 40 (mg)
    ROUNDING_INCREMENT: 125, // Round to nearest 125mg
  },
  // Gentamicin/Tobramycin dosing (mg/kg)
  GENTAMICIN_TOBRAMYCIN: {
    NORMAL_CRITICAL: 7, // Normal renal function or critical care
    INTERMEDIATE: 5, // CrCl 40-60
    REDUCED: 4, // CrCl < 40
    MAX_DOSE: 680, // Maximum dose cap (mg)
    MAX_INTERMEDIATE: 480, // Max dose for CrCl 40-60 (mg)
    MAX_REDUCED: 380, // Max dose for CrCl < 40 (mg)
    ROUNDING_INCREMENT: 20, // Round to nearest 20mg
  },
};

export const GFR_HEIGHT_RANGES = {
  cm: { MIN: 50, MAX: 220 },
  in: { MIN: 20, MAX: 86 },
};

export const HEIGHT_UNITS = [
  { label: "Centimeters (cm)", value: "cm", shortLabel: "cm" },
  { label: "Feet and inches (ft & in)", value: "in", shortLabel: "in" },
];

export const WEIGHT_UNITS = [
  { label: "Kilograms (kg)", value: "kg", shortLabel: "kg" },
  { label: "Pounds (lbs)", value: "lbs", shortLabel: "lbs" },
];

export const CREATININE_UNITS = [
  { label: "micromoles/L", value: "micromoles/L", shortLabel: "micromoles/L" },
  { label: "mg/dL", value: "mg/dL", shortLabel: "mg/dL" },
];
